import request from "@/utils/request";

export default function adminChangePwd(params) {
    return request({
        url: `/agency/agencyChangePwd`,
        method: 'post',
        params
    })
}
